// Centralized phone closure configuration

export const phoneClosureConfig = {
  // Enable/disable the entire feature
  enabled: true,

  // Closure period dates
  startDate: new Date(2026, 6, 3), // month is 0-indexed → 3.7.2026
  endDate: new Date(2026, 7, 2), // inclusive end date → 2.8.2026 (phone reappears 3.8.2026)

  messageTemplates: {
    "fi-fi":
      "Puhelin on suljettuna {startDate}-{endDate} - palvelemme tällöin sähköpostitse ja chatissa",
    "en-fi":
      "Phone is closed {startDate}-{endDate} - we serve via email and chat during this time",
    // SE market: chat is also closed for this window, so point users to email only.
    "en-se":
      "Phone is closed {startDate}-{endDate} - we serve via email during this time",
    "sv-fi":
      "Telefonen är stängd {startDate}-{endDate} - vi betjänar via e-post och chatt under denna tid",
    // SE market: chat is also closed for this window, so point users to email only.
    "sv-se":
      "Telefonen är stängd {startDate}-{endDate} - vi betjänar via e-post under denna tid",
    "en-us":
      "Phone is closed {startDate}-{endDate} - we serve via email and chat during this time",
  },
}

// Helper function to check if current date is within closure period
export const isPhoneClosurePeriod = () => {
  if (!phoneClosureConfig.enabled) return false

  const now = new Date()
  const { startDate, endDate } = phoneClosureConfig

  // Add one day to endDate to make it inclusive
  const endDateInclusive = new Date(endDate)
  endDateInclusive.setDate(endDateInclusive.getDate() + 1)

  return now >= startDate && now < endDateInclusive
}

// Date formatting function using European format for all locales
const formatDate = (date, includeYear = true) => {
  const day = date.getDate()
  const month = date.getMonth() + 1 // months are 0-indexed
  const year = date.getFullYear()

  return includeYear ? `${day}.${month}.${year}` : `${day}.${month}`
}

// Helper function to get closure message for a specific locale with formatted dates
export const getPhoneClosureMessage = (locale) => {
  if (!isPhoneClosurePeriod()) return null

  const template =
    phoneClosureConfig.messageTemplates[locale] ||
    phoneClosureConfig.messageTemplates["en-us"]
  const { startDate, endDate } = phoneClosureConfig

  // Check if both dates are in the same year
  const sameYear = startDate.getFullYear() === endDate.getFullYear()

  // Format start date without year if same year, end date always with year
  const startDateFormatted = formatDate(startDate, !sameYear)
  const endDateFormatted = formatDate(endDate, true)

  return template
    .replace("{startDate}", startDateFormatted)
    .replace("{endDate}", endDateFormatted)
}

// Helper function to check if phone should be disabled
export const shouldDisablePhone = () => {
  return isPhoneClosurePeriod()
}
